import { PrivacyDialogComponent } from './privacy-dialog/privacy-dialog.component';
import { HeaderComponent } from './header/header.component';
import { ArticleComponent } from './article/article.component';
import { FooterComponent } from './footer/footer.component';
import { TeamComponent } from './team/team.component';
import { MainComponent } from './main/main.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SlideshowModule } from 'ng-simple-slideshow';
import { Angulartics2RouterlessModule } from 'angulartics2/routerlessmodule';
import { RouterModule, Routes } from '@angular/router';
import { SlickModule } from 'ngx-slick';
import { AboutComponent } from './about/about.component';
import { BrandsComponent } from './brands/brands.component';
import { InvestorsComponent } from './investors/investors.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { HttpModule } from '@angular/http';

const ROUTES: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'brands',
    component: BrandsComponent
  },
  {
    path: 'team',
    component: TeamComponent
  },
  {
    path: 'investors',
    component: InvestorsComponent
  },
  {
    path: 'article/:id',
    component: ArticleComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MainComponent,
    AboutComponent,
    BrandsComponent,
    TeamComponent,
    InvestorsComponent,
    ArticleComponent,
    HeaderComponent,
    PrivacyDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    SlideshowModule,
    NgxPaginationModule,
    SlickModule.forRoot(),
    HttpModule,
    RouterModule.forRoot(ROUTES, { useHash: true }),
    Angulartics2RouterlessModule.forRoot(),
  ],
  providers: [

  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    PrivacyDialogComponent
  ]
})

export class AppModule {

}
